import type { RssFeedUrlResponse } from "@/modules/jobAds/client/api/types"

import { keysToCamelCase } from "@/modules/apiRequests/dataStructure"
import { getResultFromResponse } from "@/modules/apiRequests/handlers"
import { handleFetchError } from "@/modules/fetch/errorHandler"
import { fetcher } from "@/modules/fetch/fetcher"
import { CREATE_RSS_FEED_LINK_ENDPOINT } from "@/modules/jobAds/client/api/constants"

export const createRssFeedUrl = (searchParams: string): Promise<string> =>
  fetcher(`${CREATE_RSS_FEED_LINK_ENDPOINT}${searchParams}`, {
    requestInit: {
      method: "POST",
    },
    serviceDomain: "KRAKEND_API",
  })
    .then(
      getResultFromResponse<RssFeedUrlResponse>({
        transformResult: keysToCamelCase<RssFeedUrlResponse>,
      })
    )
    .then(({ rssFeedUrl }) => rssFeedUrl)
    .catch(handleFetchError(CREATE_RSS_FEED_LINK_ENDPOINT))
